import {NotificationModel} from "../../models/notification.model";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState: NotificationSliceState = {
    notifications: []
}

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setNotifications(state, action: PayloadAction<NotificationModel[]>) {
            state.notifications = action.payload;
        }
    }
});

export default notificationSlice.reducer;

export interface NotificationSliceState {
    notifications: NotificationModel[];
}
